import React from 'react';
import PropTypes from 'prop-types';
import LoaderComponent from '../common/LoaderComponent';
import ShowMoreLoaderComponent from '../common/ShowMoreLoaderComponent';
import StatusBadge from './StatusBadge';
import _ from 'lodash';
class PaymentHistoryListMobile extends React.Component {
  constructor(props) {
    super(props);
    this.renderLoader = this.renderLoader.bind(this);
    this.renderPaymentHistory = this.renderPaymentHistory.bind(this);
  }
  showPaymentDetail(paymentHistory) {
    this.props.onCustomClick(paymentHistory);
  }
  renderFooter() {
    return (
      <div className="manage-payment-history-footer">
        <p>{this.props.content.paymentHistoryMobileFooterMsg}</p>
      </div>
    );
  }
  renderLoader() {
    return <LoaderComponent type="small" />;
  }
  renderPaymentHistory() {
    const { hasError, error, paymentHistoryList, showMore, content } =
      this.props;
    if (hasError) {
      return (
        <div className="text-center">
          <div className="errormessage">{error.message}</div>
          <button
            onClick={this.props.clickToReload}
            className="c-btn c-btn--default"
          >
            Retry
          </button>
        </div>
      );
    } else {
      if (paymentHistoryList.length === 0) {
        return (
          <div className="accountGridNoTransaction text-center">
            <p>{content.paymentHistoryMobileNoDataMsg}</p>
          </div>
        );
      } else {
        const tableList = _.map(paymentHistoryList, (paymentHistory, index) => {
          return (
            <table
              id={index}
              key={index}
              className="manage-payments-table manage-payments-table-xsmall"
              cellPadding="0"
              cellSpacing="0"
              onClick={(e) => this.showPaymentDetail(paymentHistory)}
            >
              <tbody className="manage-payments-table__is-clickable">
                <tr>
                  <th width="100">Date</th>
                  <td>{paymentHistory.createdDate}</td>
                </tr>
                <tr>
                  <th>From</th>
                  <td>{`${paymentHistory.fromAccountSortCode} ${paymentHistory.fromAccountAccountNumber}`}</td>
                </tr>
                <tr>
                  <th>To</th>
                  <td className="u">
                    {paymentHistory.toAccountName
                      ? paymentHistory.toAccountName
                      : `${paymentHistory.toAccountSortCode} ${paymentHistory.toAccountAccountNumber}`}
                  </td>
                </tr>
                <tr>
                  <th>Amount</th>
                  <td className="">{paymentHistory.amount}</td>
                </tr>
                <tr>
                  <th>Status</th>
                  <td>
                    <StatusBadge status={paymentHistory.status} />
                  </td>
                </tr>
                <tr>
                  <th>Options</th>
                  <td>
                    <a className="" href="javascript:;" id={index}>
                      View
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          );
        });
        return (
          <div>
            {tableList}
            {showMore
              ? this.renderShowMore()
              : paymentHistoryList.length > 0
              ? this.renderFooter()
              : ''}
          </div>
        );
      }
    }
  }
  renderShowMore() {
    const { fetchingMore } = this.props;
    return (
      <div className="manage-payment-history-footer">
        {fetchingMore ? (
          <ShowMoreLoaderComponent />
        ) : (
          <button
            className="c-btn c-btn--default"
            onClick={this.props.loadMorePaymentList}
          >
            Show More
          </button>
        )}
      </div>
    );
  }
  render() {
    const { isFetching } = this.props;
    return (
      <div>
        <div className="manage-payments-table-container manage-payments-table-container-xsmall">
          {isFetching ? this.renderLoader() : this.renderPaymentHistory()}
        </div>
      </div>
    );
  }
}
PaymentHistoryListMobile.propTypes = {
  content: PropTypes.object,
  error: PropTypes.object,
  isFetching: PropTypes.bool,
  hasError: PropTypes.bool,
  showMore: PropTypes.bool,
  fetchingMore: PropTypes.bool,
  loadMorePaymentList: PropTypes.func,
  clickToReload: PropTypes.func,
  paymentHistoryList: PropTypes.array,
  onCustomClick: PropTypes.func,
};

PaymentHistoryListMobile.defaultProps = {
  content: {},
  isFetching: false,
  hasError: false,
  error: {
    message: 'Something went wrong',
  },
  paymentHistoryList: [],
  showMore: true,
  fetchingMore: false,
};
export default PaymentHistoryListMobile;
